import Channels from "./pages/Channels";
import Main from "./pages/Main";
import Tasks from "./pages/Tasks";
import Orders from "./pages/Orders";

import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useContext } from "react";
import { StoreContext } from '.';
import Errors from "./components/Errors";
import PaymentWindow from "./components/PaymentWindow";
import { observer } from "mobx-react-lite";
import AdminModeration from "./pages/admin/moderation";
import AdminChat from "./pages/admin/chat";


function App() {
  const tg = window.Telegram.WebApp;
  console.log(window.Telegram.WebApp);
  const {appStore} = useContext(StoreContext);

  useEffect(() => {
    try {tg.expand()} catch {console.warn('tg expand error')};
    try {(tg as any).lockOrientation()} catch {console.warn('tg lockOrientation error')};
    if (tg.platform !== 'tdesktop' && tg.platform !== 'weba') {
      try {(tg as any).requestFullscreen()} catch {console.warn('tg fullscreen error')};
    };

    appStore.initApp();
  }, []);

  return (
    <>
      <Errors/>
      {appStore.paymentWindowOpened && <PaymentWindow 
        cancel={() => {
          tg.HapticFeedback.impactOccurred("light"); 
          appStore.closePaymentWindow();
        }}
        autoPromoCode={appStore.paymentWindowAutoPromoCode}
      />}
      <Routes>
        <Route path="/offers" element={<Main/>}/>
        <Route path="/tasks" element={<Tasks/>}/>
        <Route path="/channels" element={<Channels/>}/>
        <Route path="/orders" element={<Orders/>}/>
        <Route path="/admin/moderation" element={appStore.user.admin === true ? <AdminModeration/> : <Navigate to="/offers" replace />}/>
        <Route path="/admin/chat" element={appStore.user.admin === true ? <AdminChat/> : <Navigate to="/offers" replace />}/>
        <Route path="*" element={<Navigate to="/offers" replace />}/>
      </Routes>
    </>
  );
}

export default observer(App);
